/**
 * Node for to-do item
 */
export class UserNode {
  users: UserNode[];
  item: string;
}
